module.exports = __webpack_public_path__ + "img/icon-startup-gray.861e5648.svg";